import { createSlice } from '@reduxjs/toolkit'


const slice = createSlice({
	name: 'workoutGuider',
	initialState : {
		//if true will start a 3 second countdown
		//before 
		countdown:false,
		show:false,
		//all data needed to access the correct set
		//from state
		workout_id:null,
		exercise_type:null,
		exercise_id:null,
		set_id:null,
		setIdx:null,
		//if workout end-to-end play through is active
		autoPlay:false,
		showCompleted:false,

		following_exercise_id: null,
		following_workout_id: null,
		following_exercise_type: null,
		upNext:false,

	},
	reducers : {
		update : (state,action) => {
			let upNext = action.payload.upNext;
			if (upNext) { 
				state.following_exercise_id = action.payload.exercise_id
				state.following_workout_id = action.payload.workout_id
				state.following_exercise_type = action.payload.exercise_type
				return
			}
			Object.entries(action.payload).forEach(([k,v])=>{
				state[k] = v
			})
		},
		reset : (state)=>{
			//if true will start a 3 second countdown
			//before 
			state.countdown = false
			state.show = false
			//all data needed to access the correct set
			//from state
			state.workout_id = null
			state.exercise_type = null
			state.exercise_id = null
			state.set_id = null
			state.setIdx = null
			//if workout end-to-end play through is active
			state.autoPlay = false
			state.showCompleted = false

			state.following_exercise_id = null
			state.following_workout_id = null
			state.following_exercise_type = null
		},
		toggleShow : state => { state.show = !state.show }
	},
})

export const {update,toggleShow,reset} = slice.actions
export const selectGuider = state => state.workoutGuider
export const selectShowGuider = state => state.workoutGuider.show

export default slice.reducer